import {ContentCopy} from '@mui/icons-material';
import WithEtsyAccount from '../../../pages/etsy/WithEtsyAccount';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import {HelpTutorialEnum} from '../../../variables/helpTutorial';
import EtsyCopyListing from './EtsyCopyListing';

export const etsyCopyListing: FeatureObject = {
  type: 'feature',
  title: 'Copy Listing',
  description:
    'Paste an Etsy listing URL to create a draft in your selected account with all details (selection, personalisation, images, etc.) copied from that listing.',
  IconComponent: ContentCopy,
  showFeatureFrontPage: true,
  path: '/etsyCopyListing',
  component: (user) => (
    <WithEtsyAccount
      featureName="Copy Listing"
      helpTutorialEnum={HelpTutorialEnum.ETSY_COPY_LISTING}
      component={(selectedAccount) =>
        selectedAccount ? <EtsyCopyListing selectedAccount={selectedAccount} user={user} /> : null
      }
    />
  ),
  status: FeatureStatus.PROD,
  tags: ['etsy', 'copy', 'listing', 'draft'],
};
